import { render, staticRenderFns } from "./SchoolForm.vue?vue&type=template&id=57bf8548&"
import script from "./SchoolForm.vue?vue&type=script&lang=js&"
export * from "./SchoolForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports